import React, { memo } from 'react';
import { useTranslation } from 'i18n';
import { makeEntitiesLoader } from 'hooks/makeSimpleLoader';

import { EventCategoriesActions } from 'store/actions';
import { EventCategoriesSelectors } from 'store/selectors';

import NestedMultipleFilterSelect from 'components/common/NestedSelect/NestedMultipleFilterSelect';
import { titleLabelFormatter } from './utils';

export interface IEventRootTypesProps {
  disabled?: boolean;
}

const useEventTypesState = makeEntitiesLoader(
  EventCategoriesActions.getEventCategories,
  EventCategoriesSelectors.eventTypesState,
);

const EventTypesFilter: React.FC<React.PropsWithChildren<IEventRootTypesProps>> = (props) => {
  const { disabled } = props;

  const [t] = useTranslation();
  const state = useEventTypesState();

  return (
    <NestedMultipleFilterSelect
      labelFormatter={titleLabelFormatter}
      items={state.entities}
      name="type"
      placeholderFormatter={(item: any) => item?.label || t('common:filter.type')}
      disabled={disabled || state.isFetching}
    />
  );
};

export default memo(EventTypesFilter);
